/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Step_SideInputs */

const en_us2_body_assessment_capture_step_side = /** @type {(inputs: Body_Assessment_Capture_Step_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 of 2 · side`)
};

const pt_br2_body_assessment_capture_step_side = /** @type {(inputs: Body_Assessment_Capture_Step_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 de 2 · lado`)
};

const es_419_body_assessment_capture_step_side = /** @type {(inputs: Body_Assessment_Capture_Step_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 de 2 · lado`)
};

const pt_pt2_body_assessment_capture_step_side = /** @type {(inputs: Body_Assessment_Capture_Step_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 de 2 · lado`)
};

const fr_fr2_body_assessment_capture_step_side = /** @type {(inputs: Body_Assessment_Capture_Step_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 sur 2 · profil`)
};

const de_de2_body_assessment_capture_step_side = /** @type {(inputs: Body_Assessment_Capture_Step_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 von 2 · Seite`)
};

const it_it2_body_assessment_capture_step_side = /** @type {(inputs: Body_Assessment_Capture_Step_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 di 2 · lato`)
};

/**
* | output |
* | --- |
* | "2 of 2 · side" |
*
* @param {Body_Assessment_Capture_Step_SideInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_step_side = /** @type {((inputs?: Body_Assessment_Capture_Step_SideInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Step_SideInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_step_side(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_step_side(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_step_side(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_step_side(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_step_side(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_step_side(inputs)
	return en_us2_body_assessment_capture_step_side(inputs)
});
export { body_assessment_capture_step_side as "body-assessment.capture_step_side" }